import React from 'react';
import { Box } from '@mui/material';
import type { ECharts } from 'echarts/core';
import EChartsRenderer from '../../components/EChartsRenderer';

export interface ChartProps {
  /** A complete chart definition (an ECharts option), as the agent builds it. */
  option: Record<string, unknown>;
  /** px, or any CSS height. */
  height?: number | string;
  /** Fill a container with a set height instead — an expanded view. */
  fill?: boolean;
  /** The live chart, e.g. to download it as an image. */
  onReady?: (chart: ECharts) => void;
  /** What the chart shows, for screen readers. */
  ariaLabel: string;
}

/**
 * Any chart the agent builds — bar, line, pie, scatter, heatmap, map and the
 * rest — in the app's chart theme, so it follows light and dark mode and the
 * workspace's colours.
 *
 * For a single trend over time with a fixed look, use `TrendChart`; for a
 * ranked list, `BarList`.
 */
export function Chart({ option, height = 360, fill = false, onReady, ariaLabel }: ChartProps) {
  return (
    <Box
      role="img"
      aria-label={ariaLabel}
      sx={{ width: '100%', minWidth: 0, ...(fill && { flex: '1 1 auto', minHeight: 0, height: '100%' }) }}
    >
      <EChartsRenderer option={option as Record<string, any>} height={height} fillContainer={fill} onChartReady={onReady} />
    </Box>
  );
}
